

export const TABLE_HEAD = ["GRN No","","Item","Supplier Name", "Status", "Date", "Amount", "Edit"];

export const TABLE_ROWS = [
    {
        idx: "G-001",
        name: "John Michael",
        email: "john@creative-tim.com",
        item: "Frame",
        online: true,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "G-001",
        name: "Alexa Liras",
        email: "alexa@creative-tim.com",
        item: "Photograph",
        online: false,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "G-001",
        name: "Laurent Perrier",
        email: "laurent@creative-tim.com",
        item: "Card",
        online: false,
        date: "19/09/17",
        amount: "$500"
    },
    {
        idx: "G-001",
        name: "Michael Levi",
        email: "michael@creative-tim.com",
        item: "Frame",
        online: true,
        date: "24/12/08",
        amount: "$500"
    },
    {
        idx: "G-001",
        name: "Richard Gran",
        email: "richard@creative-tim.com",
        item: "Frame",
        online: false,
        date: "04/10/21",
        amount: "$500"
    },

];


//Returned stock


export const returnedTHead = ["Item Id","","Item","Supplier Name", "Status", "Date", "Amount", "Edit"];

export const returnedDetailList = [
    {
        idx: "R-001",
        name: "John Michael",
        email: "john@creative-tim.com",
        item: "Frame",
        online: true,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "R-001",
        name: "Alexa Liras",
        email: "alexa@creative-tim.com",
        item: "Photograph",
        online: false,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "R-001",
        name: "Laurent Perrier",
        email: "laurent@creative-tim.com",
        item: "Card",
        online: false,
        date: "19/09/17",
        amount: "$500"
    },
    {
        idx: "R-001",
        name: "Michael Levi",
        email: "michael@creative-tim.com",
        item: "Frame",
        online: true,
        date: "24/12/08",
        amount: "$500"
    },
    {
        idx: "R-001",
        name: "Richard Gran",
        email: "richard@creative-tim.com",
        item: "Frame",
        online: false,
        date: "04/10/21",
        amount: "$500"
    },

];

//payment

export const paymentTHead = ["GRN Id","Supplier Id","Item","Supplier Name", "Status", "Date", "Amount", "Edit"];

export const paymentList = [
    {
        idx: "G-001",
        idx2: "S-001",
        name: "John Michael",
        email: "john@creative-tim.com",
        item: "Frame",
        online: true,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "R-001",
        idx2: "S-002",        
        name: "Alexa Liras",
        email: "alexa@creative-tim.com",
        item: "Photograph",
        online: false,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "R-001",
        idx2: "S-003",
        name: "Laurent Perrier",
        email: "laurent@creative-tim.com",
        item: "Card",
        online: false,
        date: "19/09/17",
        amount: "$500"
    },
    {
        idx: "R-001",
        idx2: "S-004",
        name: "Michael Levi",
        email: "michael@creative-tim.com",
        item: "Frame",
        online: true,
        date: "24/12/08",
        amount: "$500"
    },
    {
        idx: "R-001",
        idx2: "S-005",
        name: "Richard Gran",
        email: "richard@creative-tim.com",
        item: "Frame",
        online: false,
        date: "04/10/21",
        amount: "$500"
    },

];

//Supplier list

export const supplierTH = ["Supplier Id","", "Item", "Supplier Name", "Status", "Date","Amount","Edit"];

export const supplierTR = [
    {
        idx: "S-001",
        name: "John Michael",
        email: "john@creative-tim.com",
        item: "Frame",
        online: true,
        date: "23/04/18",
        amount: "$5400"
    },
    {
        idx: "S-002",
        name: "Alexa Liras",
        email: "alexa@creative-tim.com",
        item: "Photograph",
        online: false,
        date: "23/04/18",
        amount: "$7500"
    },
    {
        idx: "S-003",
        name: "Laurent Perrier",
        email: "laurent@creative-tim.com",
        item: "Card",
        online: false,
        date: "19/09/17",
        amount: "$5500"
    },
    {
        idx: "S-004",
        name: "Michael Levi",
        email: "michael@creative-tim.com",
        item: "Frame",
        online: true,
        date: "24/12/08",
        amount: "$700"
    },
    {
        idx: "S-005",
        name: "Richard Gran",
        email: "richard@creative-tim.com",
        item: "Frame",
        online: false,
        date: "04/10/21",
        amount: "$1500"
    },

];


//Returned stock


export const stkItemTHead = ["Item Id","","Item","Supplier Name", "Status", "Date", "Amount", "Edit"];

export const stkItemList = [
    {
        idx: "I-001",
        name: "John Michael",
        email: "john@creative-tim.com",
        item: "Frame",
        online: true,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "I-002",
        name: "Alexa Liras",
        email: "alexa@creative-tim.com",
        item: "Photograph",
        online: false,
        date: "23/04/18",
        amount: "$500"
    },
    {
        idx: "I-003",
        name: "Laurent Perrier",
        email: "laurent@creative-tim.com",
        item: "Card",
        online: false,
        date: "19/09/17",
        amount: "$500"
    },
    {
        idx: "I-004",
        name: "Michael Levi",
        email: "michael@creative-tim.com",
        item: "Frame",
        online: true,
        date: "24/12/08",
        amount: "$500"
    },
    {
        idx: "I-005",
        name: "Richard Gran",
        email: "richard@creative-tim.com",
        item: "Frame",
        online: false,
        date: "04/10/21",
        amount: "$500"
    },

];